export class Cadastro {
    pessoal_nmCliente     : string = '';
    pessoal_cdDocumento   : string = '';
    pessoal_nuDocumento   : string = '';
    pessoal_dsOcupacao    : string = '';
    pessoal_dsOrganizacao : string = '';
    pessoal_dsCEP         : string = '';     //EGS 30.11.2020 Pesquisa o endereco por CEP
    pessoal_dsEndereco    : string = '';
    pessoal_dsNumero      : string = '';
    pessoal_dsComplemento : string = '';
    pessoal_dsBairro      : string = '';
    pessoal_dsMunicipio   : string = '';
    pessoal_dsEstado      : string = '';
    pessoal_nuTelefone    : string = '';
    pessoal_dsEmail       : string = '';
    pessoal_cdSenha       : string = '';
    pessoal_cdSenha1      : string = '';
    planos                : Plano[] = [];
}

export class Plano {
    idPedido: number = 0;
    idProduto: number = 0;
    dsProduto: string = '';
    dtExpiracao: string = '';
    qtdeAtividade: number = 0;
    qtdeMunicipio: number = 0;
    qtdeUf: number = 0;
}

export class DetalhePlano {
    municipio: string[] = [];
    municipioExtra: string[] = [];
    uf: string[] = [];
    atividade: string[] = [];
}


export class OutPutGetCep {
    CEP          : number;
    logradouro   : string;
    complemento  : string;
    bairro       : string;
    localidade   : string;
    uf           : string;
    erro         : boolean;
}
export class OutputGetCidade {
    idCidade     : number
    nmCidade     : string
}
